import { PaymentAccountOverdraftQuestion } from '@hb/domain/steps/financial-obligation';
import { PaymentAccountOverdraftStoreService } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft-store.service';
import { PreviousButtonComponent } from '@hb/modules';
import { PaymentAccountOverdraftAmountComponent } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft-amount/payment-account-overdraft-amount.component';
import { PaymentAccountOverdraftTipComponent } from '@hb/modules/financial-obligations/payment-account-overdraft/payment-account-overdraft-tip/payment-account-overdraft-tip.component';

import { Subscription } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';

import { ApContentPipe } from '@ap/content';

@Component({
    selector: 'payment-account-overdraft',
    templateUrl: './payment-account-overdraft.component.html',
    imports: [PreviousButtonComponent, PaymentAccountOverdraftAmountComponent, PaymentAccountOverdraftTipComponent, ApContentPipe],
    styleUrls: ['../../global/global.scss']
})
export class PaymentAccountOverdraftComponent implements OnInit, OnDestroy {
    protected readonly store = inject(PaymentAccountOverdraftStoreService);

    protected activeQuestion: PaymentAccountOverdraftQuestion;
    private activeQuestionSubscription: Subscription;

    ngOnInit(): void {
        this.activeQuestionSubscription = this.store
            .getActiveQuestion()
            .subscribe((activeQuestion) => (this.activeQuestion = activeQuestion));
    }

    ngOnDestroy() {
        this.activeQuestionSubscription.unsubscribe();
    }

    previousQuestion(): void {
        this.store.backQuestion();
    }

    showPaymentAccountOverdraftAmount(): boolean {
        return (
            this.activeQuestion === PaymentAccountOverdraftQuestion.AMOUNT ||
            (this.store.isActiveQuestion(PaymentAccountOverdraftQuestion.AMOUNT) && this.store.isSummary)
        );
    }

    showPaymentAccountOverdraftTip(): boolean {
        return this.activeQuestion === PaymentAccountOverdraftQuestion.TIP && !this.store.isSummary;
    }
}
